import { useEffect, useState } from 'react';

const DEFAULT_OPTIONS: {
    config: MutationObserverInit;
} = {
    config: { attributes: true, childList: true, subtree: true },
};

export function useMutationObservable(
    targetEl: HTMLElement | null,
    cb: MutationCallback,
    options = DEFAULT_OPTIONS
): void {
    const [observer, setObserver] = useState<MutationObserver | undefined>();

    useEffect(() => {
        const obs = new MutationObserver(cb);
        setObserver(obs);
        return () => {
            if (obs) {
                obs.disconnect();
            }
        };
    }, [cb, options, setObserver]);

    useEffect(() => {
        if (!observer || !targetEl) return;
        const { config } = options;
        observer.observe(targetEl, config);
        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [observer, targetEl, options]);
}
